import { OverlayModule } from '@angular/cdk/overlay';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';

import { Environment } from '../../../../../src/app/website/services/environment.service';
import { TenantConfigService } from '../../../../../tenant-config/tenant-config.service';
import { environment } from '../../environments/environment';
import { DashboardModule } from '../dashboard/dashboard.module';
import { DocumentModule } from '../document/document.module';
import { ClientSharedModule } from '../shared/client-shared.module';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app/app.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SignupComponent } from './components/signup/signup.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { ClientEnvironment } from './services/client-environment.service';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { AppState } from './state/app.state';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { UnsubscribeDoneComponent } from './components/unsubscribe-done/unsubscribe-done.component';
import { UnsubscribeAbortComponent } from './components/unsubscribe-abort/unsubscribe-abort.component';
import { ErrorComponent } from './components/error/error.component';
import { SignUpModule } from '../sign-up-process/sign-up.module';
import { VerifyPhoneNumberComponent } from './components/authentication-components/verify-phone-number/verify-phone-number.component';
import { SignupShellModule } from '../shared/components/signup-shell/signup-shell.module';
import { SignupForgottenPasswordModule } from './components/signup/signup.module';
import { AdvisorSharedModule } from '../../../../../src/app/website/shared/advisor-shared.module';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    ThankYouComponent,
    ErrorComponent,
    ForgotPasswordComponent,
    UnsubscribeComponent,
    UnsubscribeDoneComponent,
    UnsubscribeAbortComponent,
    VerifyPhoneNumberComponent
  ],
  imports: [
    NgxsModule.forRoot([AppState], {
      developmentMode: !environment.production,
      compatibility: { strictContentSecurityPolicy: true }
    }),
    NgxsRouterPluginModule.forRoot(),
    // NgxsStoragePluginModule.forRoot({ key: "factfind.applicant" }),
    // NgxsLoggerPluginModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    DashboardModule,
    DocumentModule,
    SharedModule,
    ClientSharedModule,
    OverlayModule,
    SignupForgottenPasswordModule,
    SignUpModule,
    SignupShellModule,
    AdvisorSharedModule
  ],
  providers: [
    { provide: Environment, useClass: ClientEnvironment },
    {
      provide: APP_INITIALIZER,
      useFactory: (tenantConfig: TenantConfigService) => () => tenantConfig.load().toPromise(),
      deps: [TenantConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  exports: [SignupComponent]
})
export class AppModule {}
